import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, Mail, Calendar, Linkedin, Instagram, X, Zap } from "lucide-react";
import { CONTACT } from "../data/site";

const items = [
  { label: "WhatsApp", href: CONTACT.whatsapp, icon: MessageCircle, testid: "fab-whatsapp" },
  { label: "Email", href: CONTACT.email, icon: Mail, testid: "fab-email" },
  { label: "Book a Call", href: CONTACT.call, icon: Calendar, testid: "fab-call" },
  { label: "LinkedIn", href: CONTACT.linkedin, icon: Linkedin, testid: "fab-linkedin" },
  { label: "Instagram", href: CONTACT.instagram, icon: Instagram, testid: "fab-instagram" },
];

export const FloatingCTA = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-20 md:bottom-8 right-4 md:right-8 z-[60] flex flex-col items-end gap-3">
      <AnimatePresence>
        {open &&
          items.map((it, i) => (
            <motion.a
              key={it.label}
              href={it.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={it.testid}
              initial={{ opacity: 0, y: 16, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 16, scale: 0.9 }}
              transition={{ duration: 0.25, delay: (items.length - 1 - i) * 0.04 }}
              className="flex items-center gap-3 bg-white shadow-lg shadow-black/10 border border-black/5 rounded-full pl-5 pr-2 py-2 hover:border-[#0047FF] transition-colors"
            >
              <span className="font-display text-sm font-bold">{it.label}</span>
              <span className="w-9 h-9 rounded-full bg-[#0047FF] text-white flex items-center justify-center">
                <it.icon size={16} />
              </span>
            </motion.a>
          ))}
      </AnimatePresence>
      <motion.button
        onClick={() => setOpen(!open)}
        data-testid="floating-lets-talk-btn"
        whileTap={{ scale: 0.92 }}
        className={`font-display font-bold flex items-center gap-2 rounded-full px-6 py-4 shadow-xl shadow-[#0047FF]/30 transition-colors ${
          open ? "bg-[#0A0A0A] text-white" : "bg-[#0047FF] text-white hover:bg-[#0A0A0A]"
        }`}
      >
        {open ? <X size={18} /> : <Zap size={18} className="text-[#FFB6C1]" />}
        {open ? "Close" : "Let's Talk"}
      </motion.button>
    </div>
  );
};
